import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { tap, catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ErrorService } from './error.service';
import { StatusResponse } from './statusResponse';

import { AuthUser, TokenService, AuthService } from './auth/';
import { EventService } from './event.service';
import { ConfigService } from './services/config.service';

@Injectable({ providedIn: 'root' })
export class HeartbeatService {

    private heartbeatURL = ConfigService.getApiEndpoint() + 'server/heartbeat';
    online = false;
    authUser: AuthUser = this.token.whoAmI();


    constructor(
        private http: HttpClient,
        private error: ErrorService,
        private token: TokenService,
        private authService: AuthService,
        private message: EventService
    ) {
        this.beatIt(10000);
    }

    isOnline(): boolean { return this.online; }

    beatIt(timeout = 10000): void {
        //console.log('beatIt');
        if (this.token.hasToken()) {
            this.authUser = this.token.whoAmI();
            if (this.authUser.getTokenAgeInSeconds() > 300) {
                this.authService.refresh().subscribe(
                    (data) => {
                        this.token.saveToken(data.token);
                        this.authUser = this.token.whoAmI();
                    },
                    (error) => { this.message = error.message; });
            }
        }
        window.setTimeout(() => {
            this.beatIt(timeout);
        }, timeout);

    }


    heartBeat(): Observable<StatusResponse> {
        return this.http.get(this.heartbeatURL).pipe(
            retry(3),
            tap(_ => { }),
            catchError(this.error.handleError('heartBeat', null))
        );
    }
}
